// custom-instance.ts

const baseURL = "./" // use your own URL here or environment variable

import { DefaultError } from "../-components/error-context"
import {
  hasJsonContent,
  parseProblemDetails,
} from "../utils/parse-problem-details"

export const customInstance = async <T>(
  url: string,
  { method, params, body, headers }: RequestInit & { params?: any }
): Promise<T> => {
  let targetUrl = url

  if (params) {
    targetUrl += "?" + new URLSearchParams(params)
  }

  const response = await fetch(targetUrl, {
    method,
    headers,
    body,
  })
  const isJsonReponse = hasJsonContent(response)

  if (response.ok) {
    if (isJsonReponse) {
      return response.json()
    } else {
      if (response.status === 200) {
        return response.text() as unknown as T
      } else if (response.status === 204) {
        return Promise.resolve(undefined as unknown as T)
      } else {
        throw new DefaultError({ title: "Expected no content but got content" })
      }
    }
  } else {
    const problemDetails = await parseProblemDetails(response)
    if (problemDetails === null) {
      const text = await response.text()
      throw new DefaultError({ title: "Unknown error occurred", detail: text })
    } else {
      throw new DefaultError(problemDetails)
    }
  }
}

export default customInstance

// In some case with react-query and swr you want to be able to override the return error type so you can also do it here like this
export type ErrorType<Error> = Error
// In case you want to wrap the body type (optional)
// (if the custom instance is processing data before sending it, like changing the case for example)
export type BodyType<T> = T
